// Comprehensive mapping of Turkish country names to English (for react-simple-maps)
// Also includes common variations and alternative spellings
const countryNameMap = {
    // Original mappings
    "Birleşik Krallık": "United Kingdom",
    "Türkiye": "Turkey",
    "Hollanda": "Netherlands",
    "İrlanda": "Ireland",
    "Amerika": "United States of America",
    "Fransa": "France",
    "Almanya": "Germany",
    "İsveç": "Sweden",
    "Avustralya": "Australia",
    "Şili": "Chile",
    "Lüksemburg": "Luxembourg",
    "İtalya": "Italy",
    "Belçika": "Belgium",
    "Kıbrıs": "Cyprus",
    // Additional country mappings
    "İspanya": "Spain",
    "Ispanya": "Spain",
    "Portekiz": "Portugal",
    "Yunanistan": "Greece",
    "Polonya": "Poland",
    "Çekya": "Czechia",
    "Çek Cumhuriyeti": "Czechia",
    "Avusturya": "Austria",
    "İsviçre": "Switzerland",
    "Isviçre": "Switzerland",
    "Danimarka": "Denmark",
    "Norveç": "Norway",
    "Finlandiya": "Finland",
    "Rusya": "Russia",
    "Ukrayna": "Ukraine",
    "Japonya": "Japan",
    "Çin": "China",
    "Hindistan": "India",
    "Brezilya": "Brazil",
    "Arjantin": "Argentina",
    "Meksika": "Mexico",
    "Kanada": "Canada",
    "Yeni Zelanda": "New Zealand",
    "Güney Afrika": "South Africa",
    "Mısır": "Egypt",
    "İsrail": "Israel",
    "Israil": "Israel",
    "Birleşik Arap Emirlikleri": "United Arab Emirates",
    "BAE": "United Arab Emirates",
    "Suudi Arabistan": "Saudi Arabia",
    "Katar": "Qatar",
    "Singapur": "Singapore",
    "Malezya": "Malaysia",
    "Endonezya": "Indonesia",
    "Güney Kore": "South Korea",
    "Kore": "South Korea",
    "Tayvan": "Taiwan",
    "Tayland": "Thailand",
    "Vietnam": "Vietnam",
    "Filipinler": "Philippines",
    "Pakistan": "Pakistan",
    "Bangladeş": "Bangladesh",
    "İran": "Iran",
    "Iran": "Iran",
    "Irak": "Iraq",
    "Macaristan": "Hungary",
    "Romanya": "Romania",
    "Bulgaristan": "Bulgaria",
    "Hırvatistan": "Croatia",
    "Sırbistan": "Serbia",
    "Slovenya": "Slovenia",
    "Slovakya": "Slovakia",
    "Estonya": "Estonia",
    "Letonya": "Latvia",
    "Litvanya": "Lithuania",
    // Common English names that might appear
    "England": "United Kingdom",
    "UK": "United Kingdom",
    "USA": "United States of America",
    "US": "United States of America",
    "United States": "United States of America"
};

/**
 * Normalize a string by converting Turkish special characters to ASCII equivalents
 * This helps match variations like "İspanya" vs "Ispanya"
 */
function normalizeString(str) {
    if (!str) return '';
    return str
        .replace(/İ/g, 'I')
        .replace(/ı/g, 'i')
        .replace(/Ş/g, 'S')
        .replace(/ş/g, 's')
        .replace(/Ğ/g, 'G')
        .replace(/ğ/g, 'g')
        .replace(/Ü/g, 'U')
        .replace(/ü/g, 'u')
        .replace(/Ö/g, 'O')
        .replace(/ö/g, 'o')
        .replace(/Ç/g, 'C')
        .replace(/ç/g, 'c')
        .trim();
}

/**
 * Build a normalized lookup map for faster matching
 */
const normalizedCountryMap = {};
Object.entries(countryNameMap).forEach(([turkish, english]) => {
    normalizedCountryMap[normalizeString(turkish).toLowerCase()] = english;
});

/**
 * Get English country name from any input (Turkish or English)
 * Handles character variations and common misspellings
 */
function getEnglishCountryName(countryName) {
    if (!countryName) return null;
    
    const trimmed = countryName.trim();
    
    // Direct match first (fastest)
    if (countryNameMap[trimmed]) {
        return countryNameMap[trimmed];
    }
    
    // Normalized match (handles İ/I variations)
    const normalized = normalizeString(trimmed).toLowerCase();
    if (normalizedCountryMap[normalized]) {
        return normalizedCountryMap[normalized];
    }
    
    // If it's already an English name in our values, return it
    if (Object.values(countryNameMap).includes(trimmed)) {
        return trimmed;
    }
    
    // Return original if no mapping found
    return trimmed;
}

// Raw CSV data - extracted country column from Kutuk.csv (175 rows, excluding header)
// Extracted from column index 10 (Ülke)
const memberCountries = [
    "Birleşik Krallık", // 1
    "Birleşik Krallık", // 2
    "Birleşik Krallık", // 3
    "Birleşik Krallık", // 4
    "Birleşik Krallık", // 5
    "Birleşik Krallık", // 6
    "Birleşik Krallık", // 7
    "Birleşik Krallık", // 8
    "Birleşik Krallık", // 9
    "Birleşik Krallık", // 10
    "Hollanda", // 11
    "Birleşik Krallık", // 12
    "Birleşik Krallık", // 13
    "Birleşik Krallık", // 14
    "Birleşik Krallık", // 15
    "Birleşik Krallık", // 16
    "Birleşik Krallık", // 17
    "Birleşik Krallık", // 18
    "Birleşik Krallık", // 19
    "Birleşik Krallık", // 20
    "İrlanda", // 21
    "Birleşik Krallık", // 22
    "Birleşik Krallık", // 23
    "Birleşik Krallık", // 24
    "Birleşik Krallık", // 25
    "Fransa", // 26
    "Lüksemburg", // 27
    "Birleşik Krallık", // 28
    "Birleşik Krallık", // 29
    "Birleşik Krallık", // 30
    "Birleşik Krallık", // 31
    "Birleşik Krallık", // 32
    "Birleşik Krallık", // 33
    "Türkiye", // 34
    "Birleşik Krallık", // 35
    "Birleşik Krallık", // 36
    "Birleşik Krallık", // 37
    "Türkiye", // 38
    "Birleşik Krallık", // 39
    "Birleşik Krallık", // 40
    "Birleşik Krallık", // 41
    "Birleşik Krallık", // 42
    "Türkiye", // 43
    "Birleşik Krallık", // 44
    "Amerika", // 45
    "Türkiye", // 46
    "Birleşik Krallık", // 47
    "Amerika", // 48
    "Hollanda", // 49
    "Birleşik Krallık", // 50
    "Birleşik Krallık", // 51
    "Birleşik Krallık", // 52
    "Hollanda", // 53
    "Birleşik Krallık", // 54
    "Birleşik Krallık", // 55
    "İsveç", // 56
    "Birleşik Krallık", // 57
    "Birleşik Krallık", // 58
    "Türkiye", // 59
    "Birleşik Krallık", // 60
    "Birleşik Krallık", // 61
    "Birleşik Krallık", // 62
    "Türkiye", // 63
    "Birleşik Krallık", // 64
    "Birleşik Krallık", // 65
    "Birleşik Krallık", // 66
    "Birleşik Krallık", // 67
    "Birleşik Krallık", // 68
    "Birleşik Krallık", // 69
    "Birleşik Krallık", // 70
    "Birleşik Krallık", // 71
    "Birleşik Krallık", // 72
    "Türkiye", // 73
    "Hollanda", // 74
    "Birleşik Krallık", // 75
    "Birleşik Krallık", // 76
    "Birleşik Krallık", // 77
    "Birleşik Krallık", // 78
    "Birleşik Krallık", // 79
    "Birleşik Krallık", // 80
    "Birleşik Krallık", // 81
    "Birleşik Krallık", // 82
    "Birleşik Krallık", // 83
    "Birleşik Krallık", // 84
    "Birleşik Krallık", // 85
    "Birleşik Krallık", // 86
    "Birleşik Krallık", // 87
    "Birleşik Krallık", // 88
    "Birleşik Krallık", // 89
    "Birleşik Krallık", // 90
    "Birleşik Krallık", // 91
    "Birleşik Krallık", // 92
    "İrlanda", // 93
    "Türkiye", // 94
    "Birleşik Krallık", // 95
    "Birleşik Krallık", // 96
    "Birleşik Krallık", // 97
    "Birleşik Krallık", // 98
    "Birleşik Krallık", // 99
    "Türkiye", // 100
    "Türkiye", // 101
    "Birleşik Krallık", // 102
    "Birleşik Krallık", // 103
    "Almanya", // 104
    "Birleşik Krallık", // 105
    "Avustralya", // 106
    "Birleşik Krallık", // 107
    "Birleşik Krallık", // 108
    "Türkiye", // 109
    "Şili", // 110
    "Birleşik Krallık", // 111
    "Birleşik Krallık", // 112
    "Birleşik Krallık", // 113
    "Birleşik Krallık", // 114
    "Hollanda", // 115
    "Birleşik Krallık", // 116
    "Birleşik Krallık", // 117
    "Birleşik Krallık", // 118
    "Birleşik Krallık", // 119
    "İrlanda", // 120
    "Birleşik Krallık", // 121
    "Birleşik Krallık", // 122
    "Birleşik Krallık", // 123
    "Birleşik Krallık", // 124
    "Birleşik Krallık", // 125
    "Birleşik Krallık", // 126
    "Birleşik Krallık", // 127
    "Birleşik Krallık", // 128
    "Birleşik Krallık", // 129
    "Birleşik Krallık", // 130
    "Birleşik Krallık", // 131
    "Birleşik Krallık", // 132
    "Birleşik Krallık", // 133
    "Birleşik Krallık", // 134
    "Birleşik Krallık", // 135
    "Birleşik Krallık", // 136
    "Birleşik Krallık", // 137
    "Birleşik Krallık", // 138
    "Birleşik Krallık", // 139
    "Hollanda", // 140
    "Hollanda", // 141
    "Birleşik Krallık", // 142
    "Birleşik Krallık", // 143
    "Türkiye", // 144
    "İsveç", // 145
    "Birleşik Krallık", // 146
    "Türkiye", // 147
    "Türkiye", // 148
    "Türkiye", // 149
    "Lüksemburg", // 150
    "Birleşik Krallık", // 151
    "Birleşik Krallık", // 152
    "Birleşik Krallık", // 153
    "Birleşik Krallık", // 154
    "Birleşik Krallık", // 155
    "Birleşik Krallık", // 156
    "Birleşik Krallık", // 157
    "Birleşik Krallık", // 158
    "Birleşik Krallık", // 159
    "Hollanda", // 160
    "İrlanda", // 161
    "Hollanda", // 162
    "Birleşik Krallık", // 163
    "Birleşik Krallık", // 164
    "Birleşik Krallık", // 165
    "Birleşik Krallık", // 166
    "Birleşik Krallık", // 167
    "Hollanda", // 168
    "Hollanda", // 169
    "Hollanda", // 170
    "Belçika", // 171
    "Birleşik Krallık", // 172
    "Türkiye", // 173
    "Kıbrıs", // 174
    "İtalya" // 175
];

// Count members per country (using English names)
export const getMemberCounts = () => {
    const counts = {};
    
    memberCountries.forEach(country => {
        const englishName = getEnglishCountryName(country);
        if (englishName) {
            counts[englishName] = (counts[englishName] || 0) + 1;
        }
    });
    
    return counts;
};

// Get total member count
export const getTotalMembers = () => memberCountries.length;

// Get total country count
export const getTotalCountries = () => {
    const uniqueCountries = new Set(memberCountries.map(c => getEnglishCountryName(c)).filter(Boolean));
    return uniqueCountries.size;
};
